// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { caseInsensitiveEnum } from '@/constants/case-insensitive-enum';
import { z } from 'zod';

// Mirrors `enums.ChargeTriggerType` on the BE. TIME = cron sweeps the
// charge at expectedBillableDate; MANUAL = user-driven (milestone
// generated charges); EVENT = external event-driven (reserved).
export const chargeTriggerTypeSchema = caseInsensitiveEnum([
  'TIME',
  'MANUAL',
  'EVENT',
]);

export type ChargeTriggerType = z.infer<typeof chargeTriggerTypeSchema>;
